/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdateDirectiveRequest = zod
	.object({
		description: zod.string().nullish().describe('Directive description'),
		name: zod.string().optional().describe('Directive name')
	})
	.describe('Request body for updating a directive');

export type UpdateDirectiveRequest = zod.input<typeof UpdateDirectiveRequest>;
export type UpdateDirectiveRequestOutput = zod.output<typeof UpdateDirectiveRequest>;
